export default "__VITE_ASSET__BUcm$8HW__"